import { FC, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import withAuth from "../helpers/withAuth";
import Layout from "../components/Layout";
import IssueOverview from "../screens/IssueOverview";
import { IssueType } from "@store/issue/types";
import { isGeneralServiceManager, isSupervisor } from "../helpers";
import { selectCurrentRole } from "@store/user/userSelectors";
import useAppSelector from "@hooks/useAppSelector";

const GSOverviewContainer: FC = () => {
  const navigate = useNavigate();
  const role = useAppSelector(selectCurrentRole);

  useEffect(() => {
    if (role && !isGeneralServiceManager(role) && !isSupervisor(role))
      navigate("/");
  }, [role, navigate]);

  return (
    <Layout active="gs-overview">
      <IssueOverview type={IssueType.GENERAL} />
    </Layout>
  );
};

export default withAuth(GSOverviewContainer);
